import z from './createuniqueIdentifier'

const x = (y) => {
    const itemsCounter = y.reduce((b, c) => b + Number(c.count), 0)
    console.log('y',y)
    let discount_message = y.reduce((b, c) => b + ((c.price.price) * Number(c.count)), 0)

    let wages = itemsCounter * discount_message

    return { itemsCounter, discount_message, wages }
}

const f = (g, h) => {
    switch (h.type) {
        case "UPDATE_CART":
            const { discount: i, ...j } = g
            localStorage.setItem('cart', JSON.stringify({
                ...j,
                ...h.payload
            }))
            return {
                ...j,
                ...h.payload
            }
        case "ADD_ITEM": {
            const { size: size, min_width: min_width, max_width: max_width, min_height: min_height, max_height: max_height, title: title, artist: artist, frame: frame, price: price, id: id, mainImage: mainImage, passpartout: passpartout } = h.payload
            if (!frame.id) {
                alert('لطفا یک قاب برای تابلو انتخاب نمایید')
                return g
            }
            const w = z(h.payload);
                if (!g.items.find(x => x.uniqueId === w)) {
                    g.items.push({
                        ...{ id, frame, price, size, artist, title, mainImage, passpartout },
                        uniqueId: w,
                        count: 1
                    })
                }
                localStorage.setItem('cart', JSON.stringify({
                    ...g,
                    items: [...g?.items],
                    ...x(g?.items)
                }))
                return {
                    ...g,
                    items: [...g.items],
                    ...x(g.items),
                    reload: Math.random()
                }
            // if ((parseInt(k.width) <= parseInt(m) && parseInt(k.width) >= parseInt(l)) && (parseInt(k.height) <= parseInt(o) && parseInt(k.height) >= parseInt(n))) {
            //     const w = z(h.payload);
            //     if (!g.items.find(x => x.uniqueId === w)) {
            //         g.items.push({
            //             ...{ t, r, s, k, q, p, u, v },
            //             uniqueId: w,
            //             count: 1
            //         })
            //     }
            //     localStorage.setItem('cart', JSON.stringify({
            //         ...g,
            //         items: [...g.items],
            //         ...x(g.items)
            //     }))
            //     return {
            //         ...g,
            //         items: [...g.items],
            //         ...x(g.items),
            //         reload: Math.random()
            //     }
            // } else {
            //     if (parseInt(k.width) < parseInt(m) && parseInt(k.width) > parseInt(l)) {
            //         alert("ارتفاع " + `${n} <= (${k.height}) <= ${parseInt(o)}`)
            //     } else if (parseInt(k.height) < o && parseInt(k.height) > parseInt(n)) {
            //         alert("عرض " + `${l} <= (${k.width}) <= ${m}`)
            //     }
            // }
        }
        case "REMOVE_ITEM": {
            const w = z(h.payload);
            const newItems = g.items.filter(i => i.uniqueId !== w)
            localStorage.setItem('cart', JSON.stringify({
                ...g,
                items: [...newItems],
                ...x(newItems)
            }))
            return {
                ...g,
                items: [...newItems],
                ...x(newItems),
                reload: Math.random()
            }
        }
        case "INCREASE": {
            const w = z(h.payload);
            const idx = g.items.findIndex(i => i.uniqueId === w)
            let item = g.items[idx]
            item.count++
            localStorage.setItem('cart', JSON.stringify({
                ...g,
                ...x(g.items)
            }))
            return {
                ...g,
                ...x(g.items),
                reload: Math.random()
            }
        }
        case "DECREASE": {
            const w = z(h.payload);
            const idx = g.items.findIndex(i => i.uniqueId === w)
            g.items[idx].count--
            localStorage.setItem('cart', JSON.stringify({
                ...g,
                ...x(g.items)
            }))
            return {
                ...g,
                ...x(g.items),
                reload: Math.random()
            }
        }
        case "ADD_ADDRESS": {
            localStorage.setItem('cart', JSON.stringify({ ...g, address: h.payload }))
            return { ...g, address: h.payload }
        }
        case "CLEAR": {
            localStorage.setItem('cart', JSON.stringify({
                items: [],
                itemsCounter: 0,
                total: 0,
                total_price: 0,
                address: {},
            }))
            return {
                items: [],
                itemsCounter: 0,
                total: 0,
                total_price: 0,
                address: {},
            }
        }
        case "INIT_STORED_CART":
            return h.payload
        default:
            return g
    }
}

export default f
